<!--
  필터 공통 background Popup

  * 필터 리스트 관련 팝업일 경우 show 후 renderTable 함수 호출 (필수)

  @since 2018-04-04
  @author Nanhyoung.Ro <dev014>
-->
<template>
  <q-modal v-model="isOpen"
           ref="commonDialog"
           @hide="onHide"
           @show="onShow"
           :auth-force="true"
           :content-css="contentCss"
           :draggable="true"
           :noBackdropDismiss="true"
           :class="className">
    <q-modal-layout>
      <!--header-->
      <q-toolbar slot="header">
        <q-toolbar-title>{{titleName}}</q-toolbar-title>
        <q-btn flat
               :auth-force="true"
               round
               dense
               @click="minimize">
          <q-icon :class="`q-icon popup-icons ${ minimized ? 'icon-pop-title-max' : 'icon-pop-title-min' }`"></q-icon>
        </q-btn>
        <q-btn flat
               :authForce="true"
               round
               dense
               @click="hide()">
          <q-icon name="close"/>
        </q-btn>
      </q-toolbar>

      <q-toolbar slot="footer">
        <div class="contents-row">
          <div class="footer-option-group">
            <!--지우기-->
            <q-btn :label="removeLabel !== '' ? removeLabel : this.$t('lr.log_filterPopup_clear')" color="dark" outline="outline" @click="onUpdate('remove')" class="bs bs-q-btn-sm bs-q-btn-icon bs-q-btn-popup-line" :auth-force="true"/>
            <!--저장-->
            <q-btn v-if="notSave" :label="$t('cmn.save')" color="primary" @click="onUpdate('save')" class="bs bs-q-btn-sm bs-q-btn-popup" :auth-force="true"/>
            <!--검색-->
            <q-btn :label="$t('cmn.search')" color="primary" @click="onUpdate('search')" class="bs bs-q-btn-sm bs-q-btn-popup" v-if="!searchDisable" :auth-force="true"/>
          </div>
        </div>
      </q-toolbar>

      <div class="layout-padding">
        <!-- 컨텐츠 시작 -->
        <div class="content-group">

          <div v-show="notVisible" class="contents-row">
            <!-- 테이블 시작 -->
            <table class="bs-table table-bordered-none">
              <colgroup>
                <col width="30%"/>
                <col width="auto"/>
              </colgroup>
              <tbody>
                <tr v-show="toggleVisible">
                  <td class="td-head">NOT</td>
                  <td>
                    <div class="inline-group">
                      <q-toggle v-model="notChecked" :auth-force="true" class="bs bs-q-toggle bs-q-toggle-default" />
                    </div>
                  </td>

                  <!-- 양방향 추가됨 -->
                  <td v-show="showTwoway" class="td-head">
                    {{ $t('cmn.twoway') }}
                  </td>
                  <td>
                    <div v-show="showTwoway" class="inline-group" style="display: flex; justify-content: flex-end;">
                      <q-toggle
                              v-model="biChecked"
                              class="bs bs-q-toggle bs-q-toggle-default"
                              :disable="disableBidirectional"
                              :auth-force="true"
                      ></q-toggle>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <!-- 테이블 끝 -->
          </div>

          <hr v-if="notVisible" class="portlet-bottom-hr">

          <slot></slot>

        </div>
        <!-- 컨텐츠 끝 -->
      </div>

    </q-modal-layout>
  </q-modal>
</template>

<script>
  import commonDialog from '~/components/popUp/LayoutModalPopUp'

  export default {
    name: 'filter-list-dialog',
    components: {
      'common-dialog': commonDialog
    },
    props: {
      notSave: {
        type: Boolean,
        default: true
      },
      checked: {
        type: Boolean,
        default: false
      },
      notVisible: {
        type: Boolean,
        default: false
      },
      titleName: {
        type: String,
        default: ''
      },
      searchDisable: {
        type: Boolean,
        default: false
      },
      dialogEventHide: { // save나 search 시 팝업 닫는 여부
        type: Boolean,
        default: true
      },
      dialogClearHide: { // 지우기 시 닫는 여부
        type: Boolean,
        default: false
      },
      removeLabel: {
        type: String,
        default: ''
      },
      contentCss: {
        type: Object,
        default: () => {
          return {
            width: '400px',
            height: '240px'
          }
        }
      },
      className: {
        type: String,
        default: 'bs bs-q-modal bs-q-modal-flat'
      },
      toggleVisible: {
        type: Boolean,
        default: true
      },
      bidirectional: {
        type: Boolean,
        default: null
      },
      disableBidirectional: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        notChecked: false,
        isOpen: false,
        isMaxCount: false,
        minimized: false,
        biChecked: false
      }
    },
    computed: {
      showTwoway () {
        return this.bidirectional !== null
      }
    },
    methods: {
      onUpdate (type) {
        this.notChecked = (type === 'remove') ? false : this.notChecked
        this.biChecked = (type === 'remove') ? false : this.biChecked

        const sendD = { type: type, not: this.notChecked }
        // 양방향이 Null이 아니라면 > 양방향 설정이 가능한 필터라면 (Null이면 설정 불가, true / false 가능)
        if (this.bidirectional !== null) {
          sendD.bidirectional = this.biChecked
        }
        this.$emit('send', sendD)
        if (this.isMaxCount) {
          return
        }

        if (type !== 'remove' && this.dialogEventHide) {
          this.hide()
        }
        if (type === 'remove' && this.dialogClearHide) {
          const sendRemoveD = { type: 'search', not: this.notChecked }

          // 양방향이 Null이 아니라면 > 양방향 설정이 가능한 필터라면 (Null이면 설정 불가, true / false 가능)
          if (this.bidirectional !== null) {
            sendRemoveD.bidirectional = this.biChecked
          }
          this.$emit('send', sendRemoveD)
          this.hide()
        }
      },
      onHide () {
        if (this.minimized) {
          this.minimized = false
          this.$refs.commonDialog.minimize()
        }
        this.biChecked = this.bidirectional === null ? false : this.bidirectional
        this.notChecked = this.checked
        this.$emit('hide')
      },
      onShow () {
        this.$emit('show')
      },
      show () {
        this.$refs.commonDialog.show()
      },
      hide () {
        this.$refs.commonDialog.hide()
      },
      minimize () {
        this.minimized = !this.minimized
        this.$refs.commonDialog.minimize(this.minimized)
      },
      /**
       * 이름: setBidirectional
       * 설명: 외부 컴포넌트에서 양방향 값을 변경할 때 사용한다.
       */
      setBidirectional (newBi) {
        this.biChecked = newBi
      }
    },
    watch: {
      checked (chk) {
        this.notChecked = chk
      },
      bidirectional (bi) {
        this.biChecked = bi || false
      }
    }
  }
</script>

<style scoped>

</style>
